import capitalize from "lodash-es/capitalize";

import { RunState } from "types/generated";
import { getDuration } from "utils/time";

const MILLISECONDS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;

const toOneDecimal = (value: number) => Math.round(value * 10) / 10;

export const getPhaseLabel = (state: RunState) => capitalize(state.replace(/_/g, " "));

export const getDurationLabel = (seconds: number) => {
  if (seconds < 1) {
    return `${Math.round(seconds * MILLISECONDS_IN_SECOND)}ms`;
  }

  const rounded = seconds < SECONDS_IN_MINUTE ? toOneDecimal(seconds) : Math.round(seconds);

  return rounded < SECONDS_IN_MINUTE ? `${rounded}s` : (getDuration(rounded, true, false) ?? "0s");
};
